import React, { Component } from 'react';
import { Row, Col, ProgressBar, Table } from "react-bootstrap";
import CKEditor from 'ckeditor4-react';
import Select from 'react-select';
import CustomModal from "../../components/Modal/CustomModal";

import { CustomCard } from "../../components/Card/CustomCard";
import { DispNIngreso, DispRegulares, DispEstAll, EnviarNotif } from "../../funciones/EnviosFunction";
import { toast } from 'react-toastify';
import EnvioInd from './EnvioInd';


CKEditor.editorUrl = 'ckeditor/ckeditor.js';

class MainEnvios extends Component {
    state = {
        porcentaje: 0,
        contentState: "",
        boton1:{
            icon: "fa fa-send",
            text: "Enviar",
            disabled: false
        },
        botonEnvio: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        aplicarA: { value: "nIngreso", label: "- Nuevo Ingreso -" },
        estEnvio: [],
        estNoEnviados: [],
        openModalConfirm: false,
        openModalEnviOk: false,
        asunto: "",
        mensaje: ""
    }

    cambiaHtml = (e) => {
        this.setState({
            contentState: e.editor.getData()
        })
    }

    enviar = () => {
        if (this.state.boton1.disabled === true) return null;

        if (this.state.asunto === "") {
            toast.error("El campo Asunto está vacío",{autoClose: 4000});
            return null;
        }

        if (this.state.contentState === "") {
            toast.error("El mensaje está vacío",{autoClose: 4000});
            return null;
        }

        let nIngreso = () => {
            DispNIngreso ((resp) => {
                this.setState({
                    estEnvio: resp,
                    openModalConfirm: true,
                    mensaje: <div>Se enviará la notificación a <strong>{resp.length} estudiantes</strong>. ¿Deseas Continuar?</div>
                })
            })
        }

        let regulares = () => {
            DispRegulares ((resp) => {
                this.setState({
                    estEnvio: resp,
                    openModalConfirm: true,
                    mensaje: <div>Se enviará la notificación a <strong>{resp.length} estudiantes</strong>. ¿Deseas Continuar?</div>
                })
            })
        }

        let morosos = () => {
            DispEstAll ((resp) => {
                this.setState({
                    estEnvio: resp,
                    openModalConfirm: true,
                    mensaje: <div>Se va a revisar el estado de cuenta de <strong>{resp.length} estudiantes</strong> y se enviará la notificación a los <strong className="text-primary">Estudiantes Morosos</strong>. ¿Deseas Continuar?</div>
                })
            })
        }

        this.setState({
            boton1:{
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            switch(this.state.aplicarA.value){
                case "nIngreso":
                    nIngreso()
                break;
                case "regulares":
                    regulares()
                break;
                case "morosos":
                    morosos()
                break;
                default: nIngreso()
            }
        })
    }

    caplicarA = (aplicarA) => {
        this.setState({aplicarA})
    }
    
    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
        });
    }

    contenido = () => {
        let { porcentaje, contentState, boton1, aplicarA, asunto, estNoEnviados, } = this.state;

        const configuraciones = {
            toolbar: [
                [ 'Font', 'FontSize', '-', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor', 'BGColor', '-', 'JustifyCenter', 'JustifyLeft', 'JustifyRight', 'JustifyBlock', 'Image' ],
            ],
            height: "41vh",
            removePlugins: 'resize, elementspath'
        }

        const customStyles = {
            option: (provided) => ({
              ...provided,
              fontSize: 12
            }),
        }

        const aplica = [
            { value: "nIngreso", label: "- Nuevo Ingreso -" },
            { value: "regulares", label: "- Regulares -" },
            { value: "morosos", label: "- Estudiantes Morosos -" },
        ]

        let noEnviados = () => {
            if (estNoEnviados.length === 0) return null;

            const styles = {
                padding: 5, fontSize: 12
            }

            let est = () => {
                let n = 0;
                return(
                    estNoEnviados.map(option => {
                        n++;
                        return (
                            <EnvioInd option = {option} n = {n} key = {n} asunto = {asunto} html = {contentState} aplica ={aplicarA.value}/> 
                        )
                    })
                )
            }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
            return(
                <div className="custom-alert-info custom-mt-10">
                    <div style={{fontSize: 12}} align="center"><strong>No se pudo enviar la notificación a los siguientes estudiantes</strong></div>
                    <div className="table-responsive" id="lisEstDeuda" onScroll={this.update} style={{overflowY: "auto", maxHeight: "40vh", backgroundColor: "fff"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="50px" align="center" style={styles}><strong>N°</strong></td>
                                    <td align="center" style={styles}><strong>Estudiante</strong></td>
                                    <td width="50px" align="center" style={styles}></td>
                                </tr>
                                {est()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment>
                <Row>
                    <Col md = {8}>
                        <div style={{fontSize: 10}} className="text-danger">Progreso</div>
                        <ProgressBar now={porcentaje} striped style={{height: 12}}/>
                        <div align="center" style={{fontSize: 10}}>{parseInt(porcentaje)}%</div>
                    </Col>
                    <Col md = {4}>
                        <input type = "text" className="form-control" value={asunto} onChange={this.cambiaValor("asunto")} placeholder="Asunto"/>
                    </Col>
                    <Col md = {12}>{noEnviados()}</Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="new-mail-body">
                            <CKEditor
                                data = {contentState}
                                type = "classic"
                                onChange = {this.cambiaHtml} 
                                config = {configuraciones}
                            />
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="custom-alert-danger">
                            <Row>
                                <Col md={5}>
                                    <Select
                                        styles={customStyles}
                                        isSearchable ={true}
                                        value={aplicarA}
                                        onChange={this.caplicarA}
                                        options={aplica}
                                    />
                                </Col>
                                <Col md={7} align = "right">
                                    <button className="btn btn-relleno-danger" onClick={this.enviar} title="Enviar la notificación a los estudiantes seleccionados" style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md ={12} align="justify">
                En este módulo puedes enviar notificaciones por <strong>Correo Electrónico</strong> a los estudiantes
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                Para el envío de notificaciones primero coloca el <strong>ASUNTO</strong> y luego el <strong>CONTENIDO DEL MENSAJE</strong>, en el cual podrás agregar estilos mediante la barra de de formato ubicada en la parte superior del campo del contenido
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                Una vez llenado los campos selecciona a quien deseas enviar las notificaciones (ten en cuenta que el proceso puede tardar dependiendo de la cantidad de estudiantes que se les enviará la notificación)
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                Presiona el botón <button className="btn btn-relleno-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-send"></i> Enviar</button> para realizar el envío
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Al comenzar el proceso de envío podrás ver una barra de progreso como esta: <ProgressBar now={45} striped style={{height: 12}}/> que te indica el porcentaje de estudiantes que se les ha enviado la notificación
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>Es importante que esperes que se complete el proceso una vez que ha comenzado para evitar fallas del sistema</strong>
            </Col>
        </Row>
    )

    modalConfirm = () => {
        let { openModalConfirm, botonEnvio, estEnvio, contentState, asunto, mensaje, aplicarA } = this.state;
        
        let contenido = () => (
            <React.Fragment>
                {mensaje}
                <div style={{fontSize: 11}} className="text-danger"><strong>IMPORTANTE: Una vez que el proceso de envío comience no utilices el sistema hasta que finalice</strong></div>
            </React.Fragment>
        )

        let envioInd = (est, percent, respuesta) => {
            let slidePercent = 100 / ((estEnvio.length - 1));
            EnviarNotif (estEnvio[est], asunto, contentState, aplicarA.value, (resp) => {

                if (resp.status === "Error"){
                    toast.error(resp.mess,{autoClose: 6000});

                    let contenido = this.state.estNoEnviados;
                    contenido.push(resp)
                    this.setState({
                        estNoEnviados: contenido
                    })
                }

                this.setState({
                    porcentaje: Math.round(percent)
                }, () => {
                    if (est === (estEnvio.length - 1)){

                        this.setState({
                            openModalEnviOk: true,
                            boton1:{
                                icon: "fa fa-send",
                                text: "Enviar",
                                disabled: false
                            },
                            botonEnvio: {
                                icon: "fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                            porcentaje: 0
                        })
                    }
                })

                let estAct = est + 1;
                let perc = percent + slidePercent;
                if (estAct <= (estEnvio.length - 1)) envioInd(estAct, perc, (resp) => {})

                respuesta(1)
            })
        }

        let envio = () => {
            if (botonEnvio.disabled === true) return null;

            if (estEnvio.length === 0) {
                this.setState({
                    openModalConfirm: false,
                    boton1:{
                        icon: "fa fa-send",
                        text: "Enviar",
                        disabled: false
                    }
                })
                toast.info("No hay estudiantes disponibles",{autoClose: 4000});
                return null;
            }

            this.setState({
                botonEnvio: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                },
                openModalConfirm: false
            }, () => {
                let ni = 0;
                if (estEnvio.length > 0) {
                    envioInd(ni, 0, (resp) => { ni += resp })
                }
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={botonEnvio.icon}></i> {botonEnvio.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalConfirm}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {envio}
                funcion2 = {() => {this.setState({
                    openModalConfirm: false,
                    boton1:{
                        icon: "fa fa-send",
                        text: "Enviar",
                        disabled: false
                    },
                    botonEnvio: {
                        icon: "fa fa-check",
                        text: "Si",
                        disabled: false
                    }
                })}}
            />
        );
    }
    
    modalEnviOk = () => {
        let { openModalEnviOk} = this.state;

        let contenido = () => (
            <div>
                Se ha enviado correctamente la notificación a los estudiantes seleccionados
            </div>
        )

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-check"></i> Ok</React.Fragment>}
                large = "medium"
                isopen =  {openModalEnviOk}
                titulo = "Notificación Enviada"
                contenido = {contenido()}      
                funcion1 = {() => {this.setState({ openModalEnviOk: false })}}
            />
        );
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div style={{borderRadius: "4px 4px"}}>
                            <CustomCard
                                title="Envio de Notificaciones"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Envío de Notificaciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalConfirm()}
                {this.modalEnviOk()}
            </div>
        );
    }
}
 
export default MainEnvios;


// WEBPACK FOOTER //
// ./src/views/Envios/MainEnvios.jsx